export enum AppErrorCode {
  UNKNOWN = "APP::UNKNOWN_ERROR",
  RUNTIME = "APP::RUNTIME_ERROR",
}
